export { default } from "./infoCard";
